<template>
<div class="row">
  <div class="Absolute-Center is-Responsive">
    <div id="logo-container"></div>
    <div style="font-size: 2em;">
      <p style="color: black;">Dental Place Medan</p>
    </div>
    <div v-if="isLoading" class="lds-spinner"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>
    <div v-if="isLoading">Sending Email... Please Wait</div>
    <div v-if="!isLoading" class="col-sm-12">
      <div class="form-group col-md-12">
        <input type="email" class="form-control" id="app-email-address" aria-describedby="emailHelp" placeholder="Email" v-model="body.email">
      </div>
      <button class="btn btn-primary btn-block" v-on:click="isHidden = true" @click="save">Reset my password via Email</button> 
      <br>
      <button class="btn btn-primary btn-block" @click="login">Bring me back to Login!</button> 
    </div>  
  </div>    
</div>
</template>

<script>
import api from '../services/api'
import { SignUp } from '../models/signup'
import { mapActions, mapState } from 'vuex'

export default {
  data() {
    return {
      body: {email: ''},
      isHidden: false
    }
  },
  computed: {
    ...mapState(['isLoading'])
  },
  methods: {
    ...mapActions(['appLogin', 'appLoading']),
    async save() {
      this.appLoading(true)
      const signUpApi = api('member-management/request-reset-password')
      const registeredMail = await signUpApi.createWithResultAndToast(this.body)
      console.log(registeredMail.ok)
      if (registeredMail.ok) {
        this.$router.go(-1)
      }
      this.appLoading(false)
    },
    login() {
      this.$router.push({ name: 'login' })
    },
  }
}
</script>